import { TrackJS } from 'trackjs'

import { TIX_API_IGNORE_PATTERNS } from '@tix/error-tracker'

import { flags } from '@/helpers/ConfigCat'
import { environment, environmentName } from '@/helpers/Environment'

export function initializeTrackJS(): typeof TrackJS {
  // Always instantiate Track JS, regardless of the environments.
  TrackJS.install({
    token: 'dd56fb43d4e9473e9e8378c4212e2a37',
    application: `whitelabel-${environmentName}`,
    onError: ({ message, metadata }) => {
      // Ignore all Tix API network errors on the same hostname as the document.
      if (TIX_API_IGNORE_PATTERNS.some((pattern) => message.match(pattern))) return false

      metadata.push({
        key: 'Authentication method',
        value: `${environment.web.authentication_method}`,
      })

      // Add metadata about the state of the feature flags
      // https://docs.trackjs.com/browser-agent/tips-and-tricks/single-error-metadata/
      metadata.push({ key: 'Flags initialized', value: Boolean(flags).toString() })

      if (flags) {
        Object.entries(flags).forEach(([flagName, flagState]) => {
          metadata.push({ key: `Flag ${flagName}`, value: flagState.toString() })
        })
      }

      return true
    },
  })

  return TrackJS
}
